import { render, staticRenderFns } from "./WidgetNext.vue?vue&type=template&id=18492540&"
import script from "./WidgetNext.vue?vue&type=script&lang=ts&"
export * from "./WidgetNext.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports